import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  const handleCTAClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Track AddToCart event
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Quincena Milagrosa',
        content_ids: ['42994498404470'],
        content_type: 'product',
        value: 7.97,
        currency: 'USD'
      });
    }
  };
  return <section className="py-20 bg-white border-t border-amber-100" data-id="element-60">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-62">
          <h2 className="text-3xl md:text-4xl font-bold text-amber-950" data-id="element-63">
            Empieza hoy. No esperes otra quincena más.
          </h2>

          <p className="text-xl text-amber-900/80 max-w-2xl mx-auto" data-id="element-64">
            Cada quincena que pasa sin control refuerza el estrés, aumenta la
            ansiedad y normaliza vivir justo. <br data-id="element-65" />
            <span className="font-bold text-amber-800" data-id="element-66">
              Y vivir justo no debería ser normal.
            </span>
          </p>

          <div className="pt-8" data-id="element-67">
            <a href="https://almadigitalebooks.digital/cart/42994498404470:1" onClick={handleCTAClick} className="w-full sm:w-auto bg-amber-900 text-amber-50 font-bold text-lg py-4 px-10 rounded-xl shadow-lg hover:bg-amber-800 hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2 mx-auto" data-id="element-68">
              <span data-id="element-69">Accede ahora por $7.97 USD</span>
              <ArrowRight className="w-5 h-5" data-id="element-70" />
            </a>
            <p className="text-sm text-amber-900/50 mt-4" data-id="element-71">
              Incluye los 3 bonos · Acceso inmediato · Resultados reales
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}